import React, { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import Icon from "./Icon";
import { brand, navLinks, secondaryNavLinks } from "../data/siteData";
import navImg from "../assets/navimg.png";
import "../styles/Navbar.css";

// Self-contained navbar: manages its own open/close + scroll state.
// Floating pill layout, styled to match the brand's primary color.
export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  const closeMenu = () => setIsOpen(false);

  // Center nav combines the primary + secondary links, matching the
  // reference layout of evenly spaced items between the logo and CTA.
  const centerLinks = [...navLinks, ...secondaryNavLinks];

  return (
    <header className={`tp-nav ${scrolled ? "tp-nav--scrolled" : ""}`}>
      <div className="tp-nav__pill">
        <Link
          to="/"
          className="tp-nav__brand"
          onClick={closeMenu}
          aria-label={brand.name}
        >
          <span className="tp-nav__logo-wrap">
            <img
              src={navImg}
              alt={`${brand.name} — ${brand.tagline}`}
              className="tp-nav__logo"
            />
          </span>
        </Link>

        <nav className="tp-nav__links">
          {centerLinks.map((link) => (
            <NavLink
              key={link.label}
              to={link.path}
              end={link.path === "/"}
              onClick={closeMenu}
              className={({ isActive }) =>
                `tp-nav__link ${isActive ? "tp-nav__link--active" : ""}`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <Link
          to="/request-quote"
          className="tp-nav__cta"
          onClick={closeMenu}
        >
          Request a Quote
        </Link>

        <button
          className="tp-nav__toggle"
          aria-label={isOpen ? "Close menu" : "Open menu"}
          aria-expanded={isOpen}
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <Icon name={isOpen ? "close" : "menu"} size={24} />
        </button>
      </div>

      {isOpen && (
        <>
          <button
            className="tp-nav__scrim"
            aria-label="Close menu"
            onClick={closeMenu}
          />
          <nav className="tp-nav__mobile">
            {centerLinks.map((link) => (
              <NavLink
                key={link.label}
                to={link.path}
                end={link.path === "/"}
                onClick={closeMenu}
                className={({ isActive }) =>
                  `tp-nav__mobile-link ${
                    isActive ? "tp-nav__mobile-link--active" : ""
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
            <Link
              to="/request-quote"
              className="tp-nav__cta tp-nav__cta--mobile"
              onClick={closeMenu}
            >
              Request a Quote
              <Icon name="arrow" size={14} />
            </Link>
          </nav>
        </>
      )}
    </header>
  );
}
